module.exports = __webpack_public_path__ + "static/media/plane(3).48ee1478.PNG";